export const SUPPORT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL || 'support@donortrack.org';

function normalizeSupportPhoneDigits(raw) {
  let digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '254712674333';
  if (digits.startsWith('0')) digits = `254${digits.slice(1)}`;
  if (digits.length === 9) digits = `254${digits}`;
  return digits;
}

export const SUPPORT_PHONE_DIGITS = normalizeSupportPhoneDigits(
  process.env.REACT_APP_SUPPORT_PHONE || '+254712674333'
);

export const SUPPORT_PHONE_DISPLAY = `+${SUPPORT_PHONE_DIGITS}`;

export const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_PHONE_DIGITS}`;

export const SUPPORT_TEL_URL = `tel:+${SUPPORT_PHONE_DIGITS}`;

export const HELP_SECTIONS = {
  privacy: {
    title: 'Privacy Policy',
    paragraphs: [
      'DonorTrack ("we", "us") respects your privacy. This policy describes how we collect, use, and protect personal information when you use the Donor Site.',
      'We collect information you provide when you register, donate, set reminders, or contact us — such as your name, email address, phone number, and donation history. Payment processing may involve M-Pesa or other providers; we store transaction references needed to confirm and record gifts.',
      'We use your information to operate the platform, verify requests and payments, send service-related notifications (including email and SMS where you opt in), and improve security and fraud prevention.',
      'We do not sell your personal information. We may share data with service providers who help us run DonorTrack (hosting, email, SMS, payments) under confidentiality obligations, or when required by law.',
      'We retain information as long as needed for legitimate business and legal purposes. You may request access, correction, or deletion of your account data by contacting us.',
      'We use reasonable technical and organisational measures to protect your data. No online service is completely secure; please use a strong password and keep your login details private.',
      'We may update this policy from time to time. Continued use of the Donor Site after changes constitutes acceptance of the updated policy.',
      `Questions about privacy? Email ${SUPPORT_EMAIL}.`
    ]
  },
  terms: {
    title: 'Terms of Use',
    paragraphs: [
      'By using the DonorTrack Donor Site, you agree to these Terms of Use. If you do not agree, please do not use the service.',
      'DonorTrack connects donors with verified beneficiary requests. We facilitate discovery, donations, and transparency around completed payments; we do not guarantee specific outcomes for any request.',
      'You must provide accurate registration information and be legally able to make donations you initiate. You are responsible for activity under your account.',
      'Donations are generally final once confirmed through our supported payment methods. Refunds, where applicable, are handled according to our policies and applicable law.',
      'Content on the site (including beneficiary stories and payment updates) is provided for transparency. Do not misuse the platform, attempt unauthorised access, or use it for unlawful purposes.',
      'The site is provided "as is" to the extent permitted by law. We are not liable for indirect or consequential damages arising from your use of the service.',
      'We may suspend or terminate accounts that violate these terms or harm the platform or other users.',
      'These terms may be updated periodically. Material changes will be reflected on the Donor Site; continued use constitutes acceptance.',
      `For questions about these terms, contact ${SUPPORT_EMAIL}.`
    ]
  },
  contact: {
    title: 'Contact us',
    paragraphs: [
      'We are here to help with account access, donations, payment updates, reminders, and general questions about DonorTrack.',
      'For payment or receipt questions about a completed request, check the Updates tab after logging in — verified payment details are posted there when a request is closed.'
    ]
  }
};
